import React, { useState, useMemo } from "react";
import ReactApexChart from "react-apexcharts";

const PieChart = ({
  data = [],
  color = [],
  labels = [],
  style,
  onSliceClick,
}) => {
  const [series] = useState(data);

  // useMemo to only rebuild options when inputs change
  const options = useMemo(() => {
    const baseOptions = {
      chart: {
        width: 400,
        type: "pie",
      },
      labels,
      colors: color,
      responsive: [
        {
          breakpoint: 480,
          options: {
            chart: {
              width: 200,
            },
            legend: {
              position: "bottom",
            },
          },
        },
      ],
    };

    // 👇 add onClick only if onSliceClick is passed
    if (onSliceClick) {
      baseOptions.chart.events = {
        dataPointSelection: (event, chartContext, config) => {
          const sliceIndex = config.dataPointIndex;
          const sliceLabel = labels[sliceIndex];
          const sliceValue = data[sliceIndex];

          // call parent's handler
          onSliceClick({
            index: sliceIndex,
            label: sliceLabel,
            value: sliceValue,
          });
        },
      };
      // make cursor look clickable
      baseOptions.chart.toolbar = { show: false };
      baseOptions.states = {
        hover: { filter: { type: "none" } },
      };
    }

    return baseOptions;
  }, [data, labels, color, onSliceClick]);

  return (
    <div id="chart" className="pie-chart" style={style}>
      <ReactApexChart options={options} series={series} type="pie" width={400} />
    </div>
  );
};

export default PieChart;
